import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../../api/api";
import { ReactComponent as CloseIcon } from "../../../assets/icons/modal/close.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/modal/delete.svg";
import { IBlog } from "../../../types/blogs.type";
import DefaultModal from "../DefaultModal/DefaultModal";
import ModalDeleteButtons from "../forms/buttons/ModalDeletButtons/ModalDeleteButtons";
import EditBlogForm from "../forms/EditBlogForm/EditBlogForm";
import ViewBlogForm from "../forms/EditBlogForm/ViewBlogForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  blog: IBlog;
  onClose: () => void;
  onApply: () => void;
  isInfo: boolean;
}

const EditBlogModal: React.FC<Props> = (props) => {
  const [isEdit, setIsEdit] = useState(!props.isInfo);
  const [isDelete, setIsDelete] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  const onPressApply = async () => {
    props.onApply();
    props.onClose();
  };

  const onPressDelete = async () => {
    try {
      const response = await authApiService.deleteBlog(props.blog.id);
      if (response) {
        props.onApply();
        props.onClose();
      }
    } catch (err: any) {
      console.error(err);
      toast.error(
        err?.response?.data?.message || "Failed to delete blog"
      );
    }
  };

  return (
    <DefaultModal>
      <div className={styles.container}>
        {isDelete ? (
          <>
            <ModalTitle
              onClose={props.onClose}
              title="Confirm blog deletion"
              subTitle="Are you sure you want to delete this blog? This action cannot be undone."
            >
              <DeleteIcon />
            </ModalTitle>
            <ModalDeleteButtons
              onPressApply={onPressDelete}
              onPressBack={() => setIsDelete(false)}
              applyTitle="Delete"
              backTitle="Back"
            />
          </>
        ) : isEdit ? (
          <>
            <ModalTitle
              onClose={props.onClose}
              title="Edit blog"
              subTitle='Update the blog details and click "Save".'
            />
            <EditBlogForm
              onApply={onPressApply}
              onClose={() => setIsDelete(true)}
              blog={props.blog}
            />
          </>
        ) : (
          <>
            <div className={styles.header}>
              <div className={styles.upSide}>
                <span className={styles.name}>{props.blog.title}</span>
                <button className={styles.upSideButton} onClick={props.onClose}>
                  <CloseIcon />
                </button>
              </div>
            </div>
            <ViewBlogForm
              onClose={props.onClose}
              onPressEdit={() => setIsEdit(true)}
              blog={props.blog}
            />
          </>
        )}
      </div>
    </DefaultModal>
  );
};

export default EditBlogModal;
